module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("正在努力加载中...")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f63ea068"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 390
// module chunks = 55